export default __webpack_public_path__ + "static/media/app-icon.a824aa97.png";